import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Container,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  TablePagination,
  createTheme,
  Dialog, DialogTitle, DialogActions, DialogContent,
  OutlinedInput,
  MenuItem,
  FormControl,
  InputLabel,
  CardMedia,
  Select,
  Chip,
  InputAdornment,
  Checkbox
} from '@material-ui/core';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@mui/icons-material/Search';
import AlertScreen from 'src/components/Alert';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import { styled } from '@mui/system';
import { getUser } from 'src/utils/Common';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import SaveIcon from '@material-ui/icons/Save';
import { Autocomplete } from '@mui/material';
import ReceiptDetail from 'src/views/IndividualProductInquiry/receiptDetail';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AttachmentIcon from '@material-ui/icons/Attachment';
import FileData from 'src/components/Photo'
import DosyaYonetimiDialog from 'src/components/FolderManagementDialog';
import moment from 'moment';

const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});

const localeMap = {
  tr: trLocale
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    position: 'relative',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1000, // ÖNEMLİ: Card ve diğer öğelerin üstünde olması için
    color: '#fff',
  },
}));

const StyledCardMedia = styled(CardMedia)({
  height: '200px',
  backgroundSize: 'contain',
});


function UnregisteredReturns() {
  const classes = useStyles();
  const SessionUser = getUser();

  const [Alert, setAlert] = useState(false);
  const [AlertType, setAlertType] = useState('');
  const [ResponseMessage, setResponseMessage] = useState('');
  const [Loading, setLoading] = useState(false);
  const [UnregisteredReturnsData, setUnregisteredReturnsData] = useState([]);
  const [UnregisteredReturnsSearchData, setUnregisteredReturnsSearchData] = useState([]);
  const [PopupDurum, setPopupDurum] = useState(false);
  const [PopupFis, setPopupFis] = useState(false);
  const [Id, setId] = useState(0);
  const [Aktif, setAktif] = useState(1);
  const [Aciklama, setAciklama] = useState('');
  const [DetayAciklama, setDetayAciklama] = useState('');
  const [Durum, setDurum] = useState(0);
  const [search, setSearch] = React.useState('');
  const [FisNo, setFisNo] = useState(0);
  const [Notlar, setNotlar] = useState('');
  const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
  const [BirimData, setBirimData] = React.useState([]);
  const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState([]);
  const [SelectedBirim, setSelectedBirim] = React.useState([]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;
  const [PopupFile, setPopupFile] = useState(false);
  const SelectAllOption = { BirimKodu: 0, Dsc: 'Tümü' };

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('UST_BIRIM_KODU');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getBolgeAdiKoduData();
  }, []);

  const setPopupDurumOpen = (FisNo, NAKLIYE_DURUM, NOTLAR) => {
    setDurum(NAKLIYE_DURUM);
    setNotlar(NOTLAR); // Notlar alanını güncel bilgisini getireceğiz.
    setFisNo(FisNo);
    setPopupDurum(true);
  }
  const setPopupFileOpen = (FisNo) => {
    setFisNo(FisNo);
    setPopupFile(true);
  }

  const handleFisNoClick = (FisNo) => {
    setFisNo(FisNo);
    setPopupFis(true);
  }

  const handleSave = () => {

    if (Durum === 0 || Durum === "") {
      setResponseMessage("Lütfen Durum Seçiniz!");
      setAlert(true);
      setAlertType("error");
      return;
    }

    setLoading(true);
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const requestData = {
      FisNo: FisNo,
      Durum: Durum,
      Notlar: Notlar,
      UserId: SessionUser?.UserId
    };

    axios.post('/SetApolloUnregisteredReturns', requestData, config)
      .then(response => {
        var data = response.data;
        setResponseMessage(data.ErrorDescription);
        setAlert(true);
        setAlertType(data.ErrorCode === "1000" ? "error" : "success");
        getUnregisteredReturnsData(0);
        setDurum(0);
        setNotlar('');
        setFisNo(0);
        setPopupDurum(false);
      });
    setLoading(false);
  }

  const getUnregisteredReturnsData = () => {
    setLoading(true);
    axios.get(`/GetApolloUnregisteredReturns/${selectedbolgeAdiKodu?.BirimKodu}/${SelectedBirim?.BirimKodu}`)
      .then((response) => {
        const res = response.data;
        setUnregisteredReturnsData(res);
        setUnregisteredReturnsSearchData(res);

      })
      .catch((error) => {

      })
      .finally(() => {
        setLoading(false); // Hem success hem hata durumunda çalışır
      });

  }

  const handleSearch = async (event) => {
    const newString = event?.target.value;
    setSearch(newString);
    if (newString) {
      const lowercasedNewString = newString.toLowerCase('tr-TR');
      const filteredData = UnregisteredReturnsSearchData.filter(item => {
        const concatenatedStr = `${item.UST_BIRIM_KODU ?? ''} ${item.BOLGE ?? ''} ${item.KUL_BIRIM_KODU ?? ''} ${item.SERVIS ?? ''} 
        ${item.BASVURU_NEDENI ?? ''}  ${item.DURUM ?? ''} ${item.ANA_GRUP ?? ''} ${item.KUL_MODEL_KODU ?? ''} 
        ${item.MODEL ?? ''}${item.ADI ?? ''}${item.SOYADI ?? ''}${item.FIS_NO ?? ''}`;
        const lowercasedConcatenatedStr = concatenatedStr.toLowerCase('tr-TR');
        return lowercasedConcatenatedStr.includes(lowercasedNewString);
      });
      setUnregisteredReturnsData(filteredData);
    } else {
      setUnregisteredReturnsData(UnregisteredReturnsSearchData);
    }
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const sortedData = UnregisteredReturnsData.slice().sort((a, b) => {
    if (!orderBy) return 0;

    const aValue = a[orderBy];
    const bValue = b[orderBy];

    const dateFields = ['CAGRI_TARIHI'];
    const isDate = dateFields.includes(orderBy);

    if (isDate) {
      const format = 'DD.MM.YYYY HH:mm';
      const dateA = moment(aValue, format);
      const dateB = moment(bValue, format);
      return order === 'asc' ? dateA - dateB : dateB - dateA;
    }

    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return order === 'asc' ? aValue - bValue : bValue - aValue;
    }

    return order === 'asc'
      ? aValue?.toString().localeCompare(bValue?.toString())
      : bValue?.toString().localeCompare(aValue?.toString());
  });


  const paginatedData = sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const getBolgeAdiKoduData = () => {
    axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
      setBolgeAdiKodu(response?.data);
    })

  }

  const getBirimData = (BirimKodu) => {
    // if (!BirimKodu || BirimKodu.length < 1) {
    //   setBirimData([]);
    // } else {
    setLoading(true);
    axios.get(`GetBirimDataCokBolgeli?BirimKodu=${BirimKodu}`).then((response) => {
      setBirimData([SelectAllOption, ...response.data]);
      setLoading(false);
    });
    // }
  }

  const renderOption = (props, option, { selected }) => (
    <li {...props}>
      <Checkbox
        icon={icon}
        checkedIcon={checkedIcon}
        style={{ marginRight: 8 }}
        checked={selected}
      />
      {option.Dsc}
    </li>
  );

  return (
    <Page className={classes.root}>
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Alert}
        autoHideDuration={10000}
        onClose={event => setAlert(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <AlertScreen
          onClose={event => setAlert(false)}
          variant={AlertType}
          message={ResponseMessage}
        ></AlertScreen>
      </Snackbar>
      <Container maxWidth="xl">
        <Card>
          <CardHeader
            title="Kayıt Dışı İade Yönetimi"

          />
          <Divider />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={4} sm={4} lg={4} >
                <Autocomplete
                  limitTags={1}
                  size="medium"
                  fullWidth
                  value={selectedbolgeAdiKodu}
                  options={bolgeAdiKodu.length > 0 ? bolgeAdiKodu : []}
                  getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                  renderOption={renderOption}
                  onChange={(event, newValue) => {
                    setSelectedbolgeAdiKodu(newValue);
                    setSelectedBirim([]);

                    if (newValue) {
                      getBirimData(newValue.BirimKodu);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Bölge"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        style: { fontSize: 14 }
                      }}
                    />
                  )}
                  sx={{
                    '& .MuiAutocomplete-endAdornment': {
                      top: '50%',
                      transform: 'translateY(-50%)',
                    }
                  }}
                />
              </Grid>
              <Grid item xs={4} sm={4} lg={4}>
                <Autocomplete
                  limitTags={1}
                  size="medium"
                  fullWidth
                  value={SelectedBirim}
                  options={BirimData.length > 0 ? BirimData : []}
                  getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                  renderOption={renderOption}
                  onChange={(event, newValue) => {
                    // newValue?.find(x => x.Id == -1)
                    //   ? setSelectedBirim(BirimData)
                    //   : setSelectedBirim(newValue);
                    setSelectedBirim(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Servis"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        style: { fontSize: 14 }
                      }}
                    />
                  )}
                  sx={{
                    '& .MuiAutocomplete-endAdornment': {
                      top: '50%',
                      transform: 'translateY(-50%)',
                    }
                  }}
                />
              </Grid>
              <Grid item xs={2} sm={2} lg={2}>
                <OutlinedInput
                  fullWidth
                  id="input-search-card-style1"
                  placeholder="Arama"
                  value={search}
                  onChange={handleSearch}
                  autoComplete="on"
                  size="medium"
                  sx={{ fontSize: 14 }}
                  startAdornment={
                    <InputAdornment position="start">
                      <IconButton edge="start">
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid item xs={2} sm={2} lg={2}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth

                  onClick={(event) => getUnregisteredReturnsData()}
                  endIcon={<SearchIcon>Search</SearchIcon>}
                >
                  Sorgula
                </Button>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <TableContainer>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'UST_BIRIM_KODU'}
                        direction={orderBy === 'UST_BIRIM_KODU' ? order : 'asc'}
                        onClick={() => handleRequestSort('UST_BIRIM_KODU')}
                      >
                        Bölge Kodu
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'BOLGE'}
                        direction={orderBy === 'BOLGE' ? order : 'asc'}
                        onClick={() => handleRequestSort('BOLGE')}
                      >
                        Bölge
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'KUL_BIRIM_KODU'}
                        direction={orderBy === 'KUL_BIRIM_KODU' ? order : 'asc'}
                        onClick={() => handleRequestSort('KUL_BIRIM_KODU')}
                      >
                        Servis Kodu
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'SERVIS'}
                        direction={orderBy === 'SERVIS' ? order : 'asc'}
                        onClick={() => handleRequestSort('SERVIS')}
                      >
                        Servis
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'FIS_NO'}
                        direction={orderBy === 'FIS_NO' ? order : 'asc'}
                        onClick={() => handleRequestSort('FIS_NO')}
                      >
                        FişNo
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'CAGRI_TARIHI'}
                        direction={orderBy === 'CAGRI_TARIHI' ? order : 'asc'}
                        onClick={() => handleRequestSort('CAGRI_TARIHI')}
                      >
                        Çagrı Tarihi
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'BASVURU_NEDENI'}
                        direction={orderBy === 'BASVURU_NEDENI' ? order : 'asc'}
                        onClick={() => handleRequestSort('BASVURU_NEDENI')}
                      >
                        Başvuru Nedeni
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'DURUM'}
                        direction={orderBy === 'DURUM' ? order : 'asc'}
                        onClick={() => handleRequestSort('DURUM')}
                      >
                        Durum
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'NAKLIYE_DURUM'}
                        direction={orderBy === 'NAKLIYE_DURUM' ? order : 'asc'}
                        onClick={() => handleRequestSort('NAKLIYE_DURUM')}
                      >
                        Nakliye Durum
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'ANA_GRUP'}
                        direction={orderBy === 'ANA_GRUP' ? order : 'asc'}
                        onClick={() => handleRequestSort('ANA_GRUP')}
                      >
                        Ürün Grubu
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'KUL_MODEL_KODU'}
                        direction={orderBy === 'KUL_MODEL_KODU' ? order : 'asc'}
                        onClick={() => handleRequestSort('KUL_MODEL_KODU')}
                      >
                        Ürün Kodu
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'MODEL'}
                        direction={orderBy === 'MODEL' ? order : 'asc'}
                        onClick={() => handleRequestSort('MODEL')}
                      >
                        Ürün
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'ADI'}
                        direction={orderBy === 'ADI' ? order : 'asc'}
                        onClick={() => handleRequestSort('ADI')}
                      >
                        Adı
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'SOYADI'}
                        direction={orderBy === 'SOYADI' ? order : 'asc'}
                        onClick={() => handleRequestSort('SOYADI')}
                      >
                        Soyadı
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>Dosya</TableCell>
                    <TableCell>Düzenle</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    paginatedData.map((item) => (
                      <TableRow hover key={item.FIS_NO}>
                        <TableCell>{item.UST_BIRIM_KODU}</TableCell>
                        <TableCell title={item.BOLGE}>{item.BOLGE.substring(0, 6)}...</TableCell>
                        <TableCell>{item.KUL_BIRIM_KODU}</TableCell>
                        <TableCell title={item.SERVIS}>{item.SERVIS.substring(0, 10)}...</TableCell>
                        <TableCell>
                          <span
                            style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => handleFisNoClick(item.FIS_NO)}
                          >
                            {item.FIS_NO}
                          </span>
                        </TableCell>
                        <TableCell>{item.CAGRI_TARIHI}</TableCell>
                        <TableCell title={item.BASVURU_NEDENI}>{item.BASVURU_NEDENI.substring(0, 6)}...</TableCell>
                        <TableCell>{item.DURUM}</TableCell>
                        <TableCell>{item.NAKLIYE_DURUM_ACIKLAMA}</TableCell>
                        <TableCell>{item.ANA_GRUP}</TableCell>
                        <TableCell>{item.KUL_MODEL_KODU}</TableCell>
                        <TableCell title={item.MODEL}>{item.MODEL.substring(0, 10)}...</TableCell>
                        <TableCell>{item.ADI}</TableCell>
                        <TableCell>{item.SOYADI}</TableCell>
                        <TableCell>
                          <IconButton
                            color='primary'
                            onClick={() => setPopupFileOpen(item.DOSYA_FIS_NO)}
                            aria-label="settings">
                            <AttachmentIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell>
                          <IconButton
                            color='primary'
                            onClick={() => setPopupDurumOpen(item.FIS_NO, item.NAKLIYE_DURUM, item.NOTLAR)}
                            aria-label="settings">
                            <RemoveRedEyeIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={UnregisteredReturnsData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={PopupFis}
        fullWidth
        maxWidth="xl"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Fiş Detayı</DialogTitle>
        <Divider />
        <DialogContent>
          <ReceiptDetail ReceiptNumber={FisNo} />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { setPopupFis(false); }}
            endIcon={<CloseIcon />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={PopupDurum}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Durum Yönetimi</DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                disabled
                fullWidth
                id="outlined-disabled"
                label="FişNo"
                defaultValue={FisNo}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-age-native-simple">Durum</InputLabel>
                <Select
                  label="Durum"
                  variant='outlined'
                  value={Durum}
                  onChange={(e) => setDurum(e.target.value)}
                  fullWidth
                  size="small"
                >
                  <MenuItem key={0} value={0}>Nakliye Durum Seçiniz!...</MenuItem>
                  <MenuItem key={1} value={1}>Sevk Aşamasında</MenuItem>
                  <MenuItem key={2} value={2}>Sevk Edildi</MenuItem>
                  <MenuItem key={3} value={3}>Depoya Giriş Oldu</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                fullWidth
                id="outlined-disabled"
                label="Başvuru Notu"
                defaultValue={Notlar}
                variant="outlined"
                multiline
                minRows={4}
                onChange={(e) => setNotlar(e.target.value)}
              />
            </Grid>

          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { handleSave() }}
            endIcon={<SaveIcon />}
          >
            Kaydet
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { setPopupDurum(false); }}
            endIcon={<CloseIcon />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={PopupFile}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Dosya Yönetimi</DialogTitle>
        <Divider />
        <DialogContent>
          <DosyaYonetimiDialog FisNo={FisNo} />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { setPopupFile(false); }}
            endIcon={<CloseIcon />}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page >
  );
}
export default UnregisteredReturns;
